module.exports = __webpack_public_path__ + "media/career.871a99c2.mp4";